// extracted by mini-css-extract-plugin
export default {"wrapper":"jx9Xg0tL7Ma1c4E3NiC7"};